var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('header',[_c('Header',{attrs:{"msg":"Header"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('Order',{attrs:{"msg":"Order","type":"line"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }